import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.css';
import { getCaptionByType, getUnitCaption } from "../../../../../helpers/selectorFunctions";
export var MainPageSelector = function (_a) {
    var selected = _a.selected, units = _a.units, isOptionsOpened = _a.isOptionsOpened, setIsOptionsOpened = _a.setIsOptionsOpened, setSearchOption = _a.setSearchOption;
    return (_jsxs("button", { onClick: function () {
            setIsOptionsOpened(!isOptionsOpened);
            setSearchOption(0);
        }, className: "selector-main-page-wrapper", children: [_jsx("label", { className: "selector-main-page-label", children: getCaptionByType(selected, units, false) }), _jsx("p", { children: getUnitCaption(selected, units) })] }));
};
